import React, { createContext, useContext, useEffect, useState } from 'react';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authData, setAuthData] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);


  useEffect(() => {
  const url = '/api/auth/status';

  fetch(url, {
    credentials: "include"
  })
    .then(res => res.json())
    .then(data => {
      if (data.authenticated) {
        setUser(data.user);
        setAuthData(data);
      } else {
        setUser(null);
        setAuthData(data);
      }
    })
    .catch(() => {
      setUser(null);
      setAuthData(null);
    })
    .finally(() => setCheckingAuth(false));
}, []);

  return (
    <AuthContext.Provider value={{ user, authData, checkingAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
